<template>
  <div class='EnbSignatures'>
    <cont-actions>
      <adm-search place="email" @run="newValue => search(newValue)"/>
    </cont-actions>
    <adm-header
    :headers="headers"
    :list="data"
    @toggle="newValue => newValue ? ListItemSelectedPush(data) : ListItemSelectedDel(data)"
    :checkbox="false"
    />
    <div class="cont-signatures">
      <list-item
      v-for="(d, key) in data"
      :key="key"
      :chave="key"
      :headers="headers_data"
      :data="d"
      :checkbox="false"
      />
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import ContActions from '../topActions/ContActions'
import AdmHeader from '../header/AdmHeader'
import ListItem from '../ListItem'
import AdmSearch from '../topActions/AdmSearch'
export default {
  name: 'EnbSignatures',
  components: { ContActions, AdmHeader, ListItem, AdmSearch },
  data () {
    return {
      headers: [
        { text: 'id', width: '22%' },
        { text: 'nome', width: '20%' },
        { text: 'email', width: '20%' },
        { text: 'status', width: '10%' },
        { text: 'inicio teste', width: '15%' },
        { text: 'fim teste', width: '15%' }
      ],
      headers_data: [
        { chave: 'id', width: '22%' },
        { chave: 'name', width: '20%' },
        { chave: 'email', width: '20%' },
        { chave: 'status', width: '10%' },
        { chave: 'trail_start', width: '15%' },
        { chave: 'trail_end', width: '15%' }
      ],
      data: []
    }
  },
  methods: {
    ...mapActions(['GetSubscriptions', 'ListItemSelectedPush', 'ListItemSelectedDel', 'GetSubscriptionEmail']),
    search (email) {
       this.GetSubscriptionEmail(email)
         .then(res => this.data = res)
    }
  },
  created () {
    this.GetSubscriptions()
      .then(res => {
        this.data = res
      })
  }
}
</script>

<style scoped>
.EnbSignatures {
  width: 100%;
  height: 96%;
}
.cont-signatures{
  width: 100%;
  height: 89%;
}
</style>
